// ══════════════════════════════════════════════════════
// Strategy Lab — Pipeline Stepper (5 Steps)
// ══════════════════════════════════════════════════════

import { theme, fonts } from "../../theme";
import { PIPELINE_STATUS_ORDER } from "./constants";

export default function PipelineStepper({ activeTab, pipelineStatus, onTabChange, stratFile }) {
  const realIdx = PIPELINE_STATUS_ORDER.indexOf(pipelineStatus || "created");

  // v4.4.3: 5-Tab pipeline with Analyze step + Deploy (v6)
  const steps = [
    { id:"builder",     n:1, label:"Erstellen",   status: realIdx >= 0 ? "done" : "pending" },
    { id:"optimizer",   n:2, label:"Optimieren",  status: realIdx >= 3 ? "done" : (realIdx >= 0 && stratFile) ? "available" : "locked" },
    { id:"backtest",    n:3, label:"Testen",      status: realIdx >= 2 ? "done" : (realIdx >= 0 && stratFile) ? "available" : "locked" },
    { id:"walkforward", n:4, label:"Validieren",  status: realIdx >= 4 ? "done" : realIdx >= 3 ? "available" : "locked" },
    { id:"analyze",     n:5, label:"Analysieren", status: stratFile ? "available" : "locked" },
    { id:"deploy",      n:6, label:"Deploy",      status: stratFile ? "available" : "locked" },
  ];

  steps.forEach(s => {
    if (s.id === activeTab) s.status = "active";
    if (s.id === "builder") s.status = s.id === activeTab ? "active" : (realIdx >= 1 ? "done" : "available");
  });

  return <div style={{ marginBottom:20 }}>
    <div style={{ display:"flex", alignItems:"center", gap:2, overflowX:"auto", WebkitOverflowScrolling:"touch", paddingBottom:4, flexWrap:"nowrap" }}>
      {steps.map((s, i) => {
        const isActive = s.status === "active";
        const isDone = s.status === "done";
        const isLocked = s.status === "locked";
        return <div key={s.id} style={{ display:"flex", alignItems:"center" }}>
          <button
            onClick={()=>!isLocked && onTabChange(s.id)}
            disabled={isLocked}
            style={{
              display:"flex", alignItems:"center", gap:8,
              padding:"10px 16px", borderRadius:10,
              border: isActive ? `2px solid ${theme.blue}` : `1px solid ${theme.border}`,
              background: isActive ? theme.blueLight : (isDone ? theme.greenLight2 : theme.white),
              color: isActive ? theme.blueText : (isDone ? theme.greenText : (isLocked ? theme.text4 : theme.text2)),
              cursor: isLocked ? "not-allowed" : "pointer",
              fontSize:13, fontWeight:600, fontFamily:fonts.body,
              transition:"all 0.15s",
              whiteSpace:"nowrap",
              opacity: isLocked ? 0.55 : 1,
            }}
          >
            <span style={{
              width:22, height:22, borderRadius:"50%",
              background: isActive ? theme.blue : (isDone ? theme.green : theme.tint),
              color: (isActive || isDone) ? "#fff" : theme.text3,
              display:"inline-flex", alignItems:"center", justifyContent:"center",
              fontSize:11, fontWeight:700, fontFamily:fonts.mono,
            }}>{isDone ? "✓" : s.n}</span>
            <span>{s.label}</span>
          </button>
          {i < steps.length - 1 && <span style={{
            width:16, height:1, background:theme.border, margin:"0 4px",
          }}/>}
        </div>;
      })}

      {/* AI Analyst / Strategies buttons */}
      <div style={{ flex:1 }}/>
      <button
        onClick={()=>onTabChange("ai")}
        style={{
          padding:"10px 16px", borderRadius:10,
          border: activeTab==="ai" ? `2px solid ${theme.purple}` : `1px solid ${theme.border}`,
          background: activeTab==="ai" ? theme.purpleLight : theme.white,
          color: activeTab==="ai" ? theme.purpleText : theme.text2,
          cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:fonts.body,
          boxShadow: activeTab==="ai" ? "none" : theme.shadow1,
          whiteSpace:"nowrap",
        }}
      >🤖 AI Analyst</button>
      <button
        onClick={()=>onTabChange("strategies")}
        style={{
          padding:"10px 16px", borderRadius:10, marginLeft:8,
          border: activeTab==="strategies" ? `2px solid ${theme.blue}` : `1px solid ${theme.border}`,
          background: activeTab==="strategies" ? theme.blueLight : theme.white,
          color: activeTab==="strategies" ? theme.blueText : theme.text2,
          cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:fonts.body,
          boxShadow: activeTab==="strategies" ? "none" : theme.shadow1,
          whiteSpace:"nowrap",
        }}
      >📄 Strategies</button>
    </div>
  </div>;
}
